import { ApolloClient, createHttpLink, DocumentNode, gql, InMemoryCache } from '@apollo/client';
import { ReferenceFragment } from '../../../common/list/fragments';
import { authLink } from '../../auth/api';

export const client = new ApolloClient({
    link: authLink.concat(
        createHttpLink({
            uri: '/reporting/v1/'
        })
    ),
    cache: new InMemoryCache({
        addTypename: false
    })
});
export const generateReportQuery: DocumentNode = gql`
    mutation GenerateReport(
        $reportTitle: String!
        $content: String!
        $pageConfig: PDFConfigInput
        $contextTerm: String
        $tags: String
        $fileName: String
    ) {
        generateReport(
            reportTitle: $reportTitle
            content: $content
            pageConfig: $pageConfig
            contextTerm: $contextTerm
            tags: $tags
            fileName: $fileName
        ) {
            id
            reference {
                ...Reference
            }
        }
    }
    ${ReferenceFragment}
`;
